<template>
    <v-list :rounded="rounded" :dense="dense">
        <v-list-item-group v-model="selectedgroup" color="primary">
            <v-list-item v-for="l in mygroups" @click="Emit(l)">
                <v-list-item-content>
                    <v-list-item-title>
                        {{l.name}}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                        {{l.data.length}} Profile<span v-if="l.data.length!==1">s</span>
                    </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                    <v-btn icon :loading="loading===l.id">
                        <v-icon>{{icons.list}}</v-icon>
                    </v-btn>
                </v-list-item-action>
            </v-list-item>
        </v-list-item-group>
    </v-list>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props:['rounded','dense','active','groups'],
    name: "GroupList",
    components: {},
    data() {
      return {
        selectedgroup: undefined,
        mygroups: [],
        loading:false
      }
    },
    computed: {
      ...mapState(['icons'])
    },
    watch:{
      active(n,o){
        if(n){
          this.setActive()
        }
      }
    },
    mounted(){
      this.getAllLists()
    },
    methods: {
      ...mapActions(['get', 'post']),
      setActive(){
        let index = this.mygroups.findIndex(f=>{return f.id===this.active})
        if(index>-1)this.selectedgroup=index
      },
      async getAllLists() {
        if(this.groups){
          this.mygroups=this.groups
        }
        let p = await this.post({path: 'api/profilesv2/getlists', body: {}})
        this.mygroups = p
        this.setActive()
      },
      Emit(l){
        this.loading=l.id
        let em = this;
        setTimeout(function(){
          em.loading=false
          em.$emit('click',l)
        },400)
      }
    }
  }

</script>

<style scoped>

</style>